<script>
import { mapGetters } from 'vuex'
import ChargeResource from '@/resources/charge'
import TermsOfServiceLink from '../../components/TermsOfServiceLink.vue'

export default {
    name: 'AccountSubscription',
    components: { TermsOfServiceLink },
    computed: {
        ...mapGetters(['userResource', 'isApexClub', 'creditsBalance'])
    },
    methods: {
        async onUnenrollSubscription() {
            this.$refs.cancelSubscription.hide()
            await ChargeResource.creditUnenrollUser()
            this.userResource.set('credits_subscription_in_good_standing', false)
        },
        nthDayOfMonth(day) {
            const moment = require('moment')
            return moment(day, 'D').format('Do')
        }
    }
}
</script>

<template>
    <div>
        <div class="mb-4">
            <h4 class="mb-1">Suscripción</h4>
            <p class="text-muted mb-0">Administra tu membresía de {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}.</p>
        </div>

        <b-card v-if="userResource.attributes.credits_subscription_in_good_standing">
            <dl class="row mb-0">
                <dt class="col-sm-4">Apex Club</dt>
                <dd class="col-sm-8"><strong class="text-success"><b-icon icon="patch-check-fill" /> Miembro</strong></dd>
                <dt class="col-sm-4">Saldo de Créditos</dt>
                <dd class="col-sm-8"><strong><b-icon icon="currency-exchange" /> {{ creditsBalance }} Créditos</strong></dd>
                <dt class="col-sm-4">Suscripción</dt>
                <dd class="col-sm-8">
                    <strong><b-icon icon="arrow-repeat" /> {{ userResource.attributes.credits_recurring }} créditos mensuales el {{ nthDayOfMonth(userResource.attributes.credits_cycle_day_of_month) }} — {{ currencySymbol() }}{{ moneyFormat(userResource.attributes.credits_recurring_cents) }}</strong>
                </dd>
            </dl>
            <template #footer>
                <small><a href="javascript:{};" class="text-muted" @click="$refs.cancelSubscription.show()">Cancelar Suscripción</a></small>
            </template>
        </b-card>

        <b-alert variant="danger" show v-else-if="!userResource.attributes.credits_subscription_in_good_standing && userResource.attributes.credits_subscription_exists">
            <strong>¡Oh no!</strong> Tu membresía de {{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }} no está en buen estado. Por favor
            <router-link :to="{ name: 'accountPayment' }">revisa tu Método de Pago</router-link> para solucionar esto.
        </b-alert>

        <b-alert variant="info" show v-else>
            <strong>Ahorra un 20% en cada carrera</strong> uniéndote al <strong>{{ $appConfig('APEX_CLUB_NAME', 'Apex Club') }}</strong>. (¡Y mucho más!)
            <router-link :to="{ name: 'subscription' }">Más Información</router-link>
        </b-alert>

        <b-modal
            title="Cancelar Suscripción"
            ref="cancelSubscription"
            @ok="onUnenrollSubscription()"
            :ok-disabled="!userResource.attributes.credits_subscription_cancelable"
            cancel-title="No Cancelar"
            cancel-variant="primary"
            ok-title="Cancelar Suscripción"
            ok-variant="danger"
            centered
            no-fade>
            <p>¿Estás seguro de que deseas cancelar tu suscripción? Esta acción es irreversible.
                <span v-if="creditsBalance > 0"> <strong>¡Perderás tu saldo de {{ creditsBalance }} Créditos!</strong> Considera usar tus créditos antes de cancelar.</span>
            </p>
            <b-alert variant="danger" :show="!userResource.attributes.credits_subscription_cancelable">
                <strong>Lo sentimos, no puedes cancelar todavía</strong> — debes ser miembro durante al menos dos ciclos de facturación. Por favor revisa nuestros <terms-of-service-link text="Términos de Servicio" el="span" />.
            </b-alert>
        </b-modal>
    </div>
</template>
